// frontend/src/services/simplify.js
// Service for Simplify session management

import { API_BASE } from "../config/api";
import { httpRequest } from "../utils/httpClient";
import { authService } from "./auth";
import logger from '../utils/logger';

export const simplifyService = {
  // Create a new Simplify session with preferences and recommendations
  createSession: async (sessionData, chosenGameId = null) => {
    try {
      const response = await httpRequest(`${API_BASE}/simplify/session`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          ...authService.getAuthHeaders(),
        },
        body: JSON.stringify({
          session_data: sessionData,
          chosen_game_id: chosenGameId,
        }),
      });

      if (!response.ok) {
        throw new Error("Failed to create Simplify session");
      }

      return await response.json();
    } catch (error) {
      logger.error("Error creating Simplify session:", error);
      throw error;
    }
  },

  // Update an existing Simplify session (e.g., when user chooses a game)
  updateSession: async (sessionId, sessionData, chosenGameId = null) => {
    try {
      const response = await httpRequest(`${API_BASE}/simplify/session/${sessionId}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          ...authService.getAuthHeaders(),
        },
        body: JSON.stringify({
          session_data: sessionData,
          chosen_game_id: chosenGameId,
        }),
      });

      if (!response.ok) {
        throw new Error("Failed to update Simplify session");
      }

      return await response.json();
    } catch (error) {
      logger.error("Error updating Simplify session:", error);
      throw error;
    }
  },

  // Get the latest Simplify session for the current user
  getLatestSession: async () => {
    try {
      const response = await httpRequest(`${API_BASE}/simplify/sessions/latest`, {
        method: "GET",
        headers: authService.getAuthHeaders(),
      });

      if (!response.ok) {
        throw new Error("Failed to get latest Simplify session");
      }

      return await response.json();
    } catch (error) {
      logger.error("Error getting latest Simplify session:", error);
      throw error;
    }
  },

  // Mark a Simplify session as completed
  completeSession: async (sessionId) => {
    try {
      const response = await httpRequest(`${API_BASE}/simplify/session/${sessionId}/complete`, {
        method: "PUT",
        headers: authService.getAuthHeaders(),
      });

      if (!response.ok) {
        throw new Error("Failed to complete Simplify session");
      }

      return await response.json();
    } catch (error) {
      logger.error("Error completing Simplify session:", error);
      throw error;
    }
  },
};
